import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/blog/article/index.ts